export default __webpack_public_path__ + "static/media/maybank.8135b6a7.ico";